module.exports = __webpack_public_path__ + "img/MINT-alt.0b0bac9f.svg";